export interface OdometerReading {
  value: number;
  unit: string;
}

export const odometerReadingInitialState: OdometerReading = {
  value: 0,
  unit: '',
};
